import store from "@/redux/store";
import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import Message from "./message";
import {logoutUser}  from "@/reducers/Authorisation";
import { filesInit, setSelectedMap } from '@/reducers/Files'

export interface ChatState {
  messages: Message[];
  notifications: Message[];
  isEstablishingConnection: boolean;
  isConnected: boolean;
  tot:number;
}
 
const initialState: ChatState = {
  messages: [],
  notifications: [],
  isEstablishingConnection: false,
  isConnected: false,
  tot:0
};
 
const messageSlice = createSlice({
  name: 'chat',
  initialState,
  reducers: {
    stopConnecting: (state => {
      state.isEstablishingConnection = false;
      state.isConnected = false;
    }),
    startConnecting: (state => {
        
      state.isEstablishingConnection = true;
    }),
    connectionEstablished: (state => {
      state.isConnected = true;
      state.isEstablishingConnection = true;
    }),
    receiveAllMessages: ((state, action: PayloadAction<{
      messages: Message[]
    }>) => {
      state.messages = action.payload.messages;
    }),
    receiveMessage2: ((state, action:any) => {
    
    }),
    receiveMessage: ((state, action) => {
        if((action.type == 'USER_LOGIN/fulfilled' || action.type == 'USER_LOGOUT/fulfilled')) return;
        
        //let item = JSON.parse(action.payload.data);
        let item = JSON.parse(action.payload.event.data);
        if(item.type == "NOTIFICATION") {
            state.messages.push(item);
            state.tot += 1;
            if(state && Array.isArray(state.messages) && state.messages.length > 5) {
                state.messages.pop();
            }
      } else {
        
            if(item && item?.message != "") {
                
          state.notifications.push(item);
            }
      }
      
    }),
    submitMessage: ((state, action: PayloadAction<{
      content: string
    }>) => {

      return;
    })
  },
  extraReducers(builder) {
    builder.addMatcher(
      (action) => action.type.endsWith('/fulfilled'),
      (state, action) => {
            if((action.type == 'USER_LOGIN/fulfilled' || action.type == 'USER_LOGOUT/fulfilled')) return;
        
          if(action['payload'] && action["payload"]["data"] && action["payload"]["data"]["message"]) {
              state.messages.push(action["payload"]["data"]["message"]);
        }
      }
    )
    
    builder.addMatcher(
      (action) => action.type.endsWith('/rejected'),
      (state, action) => {
          if((action.type == 'USER_LOGIN/rejected' || action.type == 'USER_LOGOUT/rejected')) return;
          
          if(action['payload'] && action["payload"]["data"] && action["payload"]["data"]["data"]["message"]) {
              state.messages.push(action["payload"]["data"]["data"]["message"]); 
        }
      }
    )    
  },  
});
 
export const messageActions = messageSlice.actions;
 
export default messageSlice;

